export interface IFormFieldSelectOptionAdvancedOptions {
  tag?: string;
  secondaryText?: string;
  tertiaryText?: string;
  current?: boolean;
}

export interface IResponseError {
  property: string;
  message: string[];
}

export enum FormName {
  SIGN_UP_FRESH = "sign-up-fresh",
  SIGN_UP_DIRECT_FRESH = "sign-up-direct-fresh",
}